var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.615 1.59486C14.7614 1.67635 14.8763 1.80454 14.9413 1.95896C15.0064 2.11338 15.0179 2.28515 14.974 2.44686L12.982 9.74986H20.25C20.3961 9.74987 20.5391 9.79258 20.6613 9.87276C20.7835 9.95293 20.8796 10.0671 20.9378 10.2011C20.9961 10.3352 21.0138 10.4834 20.989 10.6274C20.9641 10.7714 20.8977 10.9051 20.798 11.0119L10.298 22.2619C10.1836 22.3847 10.0313 22.4656 9.86558 22.4916C9.69981 22.5177 9.53009 22.4874 9.38357 22.4056C9.23704 22.3238 9.12218 22.1952 9.05735 22.0405C8.99252 21.8857 8.98146 21.7137 9.02595 21.5519L11.018 14.2499H3.74995C3.60379 14.2498 3.46082 14.2071 3.33861 14.127C3.2164 14.0468 3.12028 13.9327 3.06206 13.7986C3.00384 13.6645 2.98607 13.5164 3.01092 13.3723C3.03578 13.2283 3.10217 13.0947 3.20195 12.9879L13.702 1.73786C13.8163 1.6155 13.9683 1.53495 14.1338 1.50903C14.2993 1.48312 14.4687 1.51333 14.615 1.59486Z",
    fill: "#08245C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNow);
export default __webpack_public_path__ + "static/media/now.ec469a461b522a3f16dba551361b4163.svg";
export { ForwardRef as ReactComponent };